export const EMBEDDED_VIDEO = 'embedded-video';
